import React from 'react';

const Team = () => {
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-3xl font-bold tracking-tight">Team</h1>
        <p className="text-muted-foreground">Manage team members and permissions</p>
      </div>
      <div className="flex h-[400px] items-center justify-center rounded-lg border border-dashed border-border bg-card">
        <p className="text-muted-foreground">Team management coming soon...</p>
      </div>
    </div>
  );
};

export default Team;

